import { computed, type Ref } from 'vue';

/** Excludes view-control filters (e.g., shopper_seg_sections) from the filters used to build a query key. */
export function useFiltersForQueryKey(
  selectedFilters: Ref<Record<string, unknown> | undefined>,
  excludedFilterKeys: string[]
) {
  return computed(() => {
    const hasNoExclusions = excludedFilterKeys.length === 0;
    if (hasNoExclusions) {
      return selectedFilters.value;
    }
    if (!selectedFilters.value) {
      return selectedFilters.value;
    }

    const keptEntries = Object.entries(selectedFilters.value).filter(
      ([filterKey]) => !excludedFilterKeys.includes(filterKey)
    );
    return Object.fromEntries(keptEntries);
  });
}
